import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Input} from "reactstrap"
import {limitSetting} from "../helpers/skuFilter"
import Button from "reactstrap/es/Button"
import ChangeStatusProduct from "./data/bulkActions/ChangeStatusProduct"
import DeleteProduct from "./data/bulkActions/DeleteProduct"

class SkuTotal extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isOpen: false,
        }
    }

    _toggleOpen = () => {
        this.setState({
            isOpen: !this.state.isOpen,
        })
    }
    _handleChangeLimit = (e) => {
        const {value} = e.target
        const {onChangeLimit} = this.props

        if (typeof onChangeLimit === 'function') {
            onChangeLimit(parseInt(value))
        }
    }

    render() {
        const {total, limit, arrSelected, onRefresh} = this.props
        const {isOpen} = this.state

        return (
            <div className="SkuTotal d-flex justify-content-between align-items-center mb-3">
                <div className='d-flex align-content-center'>
                    <div className='d-flex align-items-center'>
                        <div className="CustomSelect">
                            <Button onClick={this._toggleOpen}
                                    className="dropdown-toggle" disabled={arrSelected.length === 0}>Hành động</Button>
                            <div className={isOpen ? 'ListAction open' : 'ListAction'}>
                                <ChangeStatusProduct arrSelected={arrSelected} closeOpen={this._toggleOpen} onRefresh={onRefresh}/>
                                <DeleteProduct arrSelected={arrSelected} closeOpen={this._toggleOpen} onRefresh={onRefresh}/>
                            </div>
                            {
                                isOpen && <div className="Background" onClick={this._toggleOpen}/>
                            }
                        </div>
                        <div className='ml-2'>
                            Đã chọn <strong>
                                {arrSelected.length}</strong> sản phẩm

                        </div>
                    </div>

                </div>
                <div className='d-flex align-items-center'>
                    <div className='d-flex align-items-center mr-3'>
                        <div>Hiển thị</div>
                        <Input type='select' value={limit} name='limit' onChange={this._handleChangeLimit}
                               className='ml-1 mr-1 w-auto'>
                            {
                                limitSetting.map(item => {
                                    return <option key={item.value} value={item.value}>{item.name}</option>
                                })
                            }
                        </Input>
                    </div>
                    <div>
                        Tổng số <strong>{total}</strong> sản phẩm
                    </div>
                </div>
            </div>
        )
    }
}

SkuTotal.propTypes = {
    products: PropTypes.array,
    total: PropTypes.number
}

export default SkuTotal